<template>
    <div class="ui-page-title" data-test="ui-page-title" :style="styles">
        <component :is="blok.headingType ? blok.headingType : 'h2'" class="page-title-inner">
            {{ blok.title }}
        </component>
    </div>
</template>

<script setup lang="ts">
import type { IPageTitle } from '@nuxt-monorepo/ui/types/components/PageTitle';

const { blok } = defineProps<{ blok: IPageTitle }>();

const styles = computed(() => ({
    color: blok.textColor?.color ? blok.textColor.color : null,
    fontSize: blok.fontSize ? `${blok.fontSize}rem` : null,
    fontWeight: blok.fontWeight ? blok.fontWeight : null,
    marginTop: blok.marginTop ? `${blok.marginTop}rem` : null,
    marginBottom: blok.marginBottom ? `${blok.marginBottom}rem` : null,
    textAlign: blok.textAlign ? blok.textAlign : null,
}));
</script>

<style lang="postcss"></style>
